export const activeSelector = state => state.uiState.app.active
